<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('transferOrders')">
                    <f7-nav-right>
                        <f7-link v-if="$helper.hasPermission('waste_out_view') && $helper.hasPermission('waste_out_create')" @click="goToWasteOut" :title="$ml.get('wasteOutOrders')">
                            <i class="f7-icons">delete</i>
                        </f7-link>
                        <f7-link @click="save">{{ $ml.get('save') }}</f7-link>
                    </f7-nav-right>
                </cm-navbar>
                <!-- END header -->

                <!-- body -->
                <f7-block-title>{{ $ml.get('basicInfo') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('action')" smart-select :smart-select-params="{openIn: 'sheet', closeOnSelect: true,}">
                        <select name="action_id" v-model="form.action_id" v-validate="'required'">
                            <option v-for="item in actions" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('shift')" smart-select :smart-select-params="{openIn: 'sheet', closeOnSelect: true,}">
                        <select name="shift_id" v-model="form.shift_id" v-validate="'required'">
                            <option v-for="item in shifts" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('device')" smart-select :smart-select-params="{openIn: 'sheet', closeOnSelect: true,}">
                        <select name="device_id" v-model="form.device_id" v-validate="'required'">
                            <option v-for="item in devices" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="text" :label="$ml.get('notes')" clear-button :value="form.note" @input="form.note = $event.target.value" name="note"></f7-list-input>

                    <f7-list-input v-if="showSolo" type="text" :label="$ml.get('solo')" clear-button :value="form.solo" @input="form.solo = $event.target.value" name="solo"></f7-list-input>

                    <f7-list-item :title="$ml.get('documents')">
                        <input type="file" ref="fileupload" multiple v-on:change="fileChange($event.target.files)" />
                    </f7-list-item>
                </f7-list>

                <f7-block-title>{{ $ml.get('transferFrom') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>

                    <f7-list-item :title="$ml.get('material')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="from_material" v-model="form.from_material" v-validate="'required'">
                            <option v-for="item in materials" :value="item.id" :key="item.id">[{{ item.materialtype.name }}] {{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('containers')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="from_container" v-model="form.from_container" v-validate="'required'">
                            <optgroup v-for="(type, index1) in fromContainers" :key="index1" :label="type.name">
                                <option v-for="(container, index2) in type.containers" :key="index2" :value="container.id">{{ container.inventory.code }}: {{ container.name }} ({{ $ml.get('having') }}: {{ $helper.numFormat(container.capacity) }})</option>
                            </optgroup>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="number" :label="$ml.get('amount')" placeholder="0" clear-button :value="form.from_amount" @input="form.from_amount = $event.target.value" name="from_amount" v-validate="'required'"></f7-list-input>
                </f7-list>

                <f7-block-title>{{ $ml.get('transferTo') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>

                    <f7-list-item :title="$ml.get('material')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="to_material" v-model="form.to_material" v-validate="'required'">
                            <option v-for="item in materials" :value="item.id" :key="item.id">[{{ item.materialtype.name }}] {{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('containers')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                        <select name="to_container" multiple v-model="form.to_container" v-validate="'required'">
                            <optgroup v-for="(type, index1) in filterContainers" :key="index1" :label="type.name">
                                <option v-for="(container, index2) in type.containers" :key="index2" :value="container.id">{{ container.inventory.code }}: {{ container.name }} ({{ $ml.get('space') }}: {{ $helper.numFormat(container.max_capacity - container.capacity) }})</option>
                            </optgroup>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('bin')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="bin" v-model="form.bin">
                            <option v-for="item in $constant.bins" :value="item" :key="item">{{ item }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="number" :label="$ml.get('amount')" placeholder="0" clear-button :value="form.to_amount" @input="form.to_amount = $event.target.value" name="to_amount" v-validate="'required'"></f7-list-input>
                </f7-list>
                <!-- END body -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'
    import CMNavbar from './Navbar'
    const lo        = require('lodash')

    export default {
        name: 'FromAddTO',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                form: {
                    action_id:      null,
                    shift_id:       null,
                    device_id:      null,
                    from_amount:    '',
                    to_amount:      '',
                    from_material:  '',
                    to_material:    '',
                    from_container: '',
                    to_container:   [],
                    description:    'Chạy máy',
                    documents:      null,
                    solo:           '',
                    bin:            '',
                    note:           '',
                },
                actions:   [],
                shifts:    [],
                materials: [],
                devices:   [],
                fromContainers: [],
                toContainers:   [],
                files: null,
                showSolo: false,
            }
        },
        computed: {
            filterContainers: function() {
                let self = this
                let result = []
                this.toContainers.forEach((type) => {
                    let containers = []
                    type.containers.forEach((con) => {
                        if (con.id !== self.form.from_container)
                            containers.push(con)
                    })
                    result.push({
                        'id': type.id,
                        'name': type.name,
                        'containers': containers,
                    })
                })

                return result
            },
        },
        methods: {
            resetForm() {
                this.form = {
                    action_id:      null,
                    device_id:      null,
                    shift_id:       null,
                    from_amount:    null,
                    to_amount:      null,
                    from_material:  null,
                    to_material:    null,
                    from_container: null,
                    to_container:   [],
                    description:    'Chạy máy',
                    documents:      null,
                    solo:           '',
                    bin:            '',
                    note:           '',
                }
                this.files = null
                this.$refs.fileupload.value = null
                this.$helper.clearAll()
            },

            fileChange(fileList) {
                this.files = fileList
                this.form.documents = '$files'
            },

            goToWasteOut() {
                return this.$router.push({name: 'WasteOut'})
            },

            checkValid(id) {
                return !! this.fromContainers.find(o => o.id === id)
            },

            async getContainers(material_id = 1, strict = true) {
                let result = await Query.withContainersByType({'material_id': material_id, 'strict': strict}).get()

                return this.$helper.data(result, 'container_by_type')
            },

            async getFromContainers(material_id) {
                this.fromContainers = await this.getContainers(material_id)
            },

            async getToContainers(material_id) {
                this.toContainers = await this.getContainers(material_id, false)
            },

            async save() {
                if (! await this.$validator.validateAll())
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))
                if (this.showSolo && (! this.form.solo || this.form.solo === ''))
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredSolo'), this.$ml.get('errors.title'))
                if (this.form.from_amount <= 0 ||
                    this.form.to_amount <= 0)
                    return this.$f7.dialog.alert(this.$ml.get('errors.greaterZero'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                /* prepare form data && submit */
                let params          = lo.clone(this.form)
                params.to_container = this.$helper.toString(params.to_container)
                let result          = await Mutation
                    .addFiles(this.files)
                    .addTO(params)
                    .execute()

                /* check & show error */
                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)
                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                return this.$f7.dialog.alert(
                    this.$ml.get('success.addTO'),
                    this.$ml.get('information'),
                    () => this.resetForm()
                )
            },
        },

        async created() {
            let formData   = await Query.withActions().withShifts().withMaterials().withListDevices().get();
            this.actions   = this.$helper.data(formData, 'actions')
            this.shifts    = this.$helper.data(formData, 'shifts')
            this.devices   = this.$helper.data(formData, 'list_devices')
            this.materials = this.$helper.data(formData, 'materials')
            await this.getFromContainers(this.materials[0].id)
            await this.getToContainers(this.materials[0].id)
        },

        watch: {
            'form.from_material' (val) {
                this.getFromContainers(val)
            },
            'form.to_material' (val) {
                this.getToContainers(val)
            },
            'form.to_container' (val) {
                this.toContainers.forEach((item) => {
                    item.containers.forEach((container) => {
                        if (val.length > 0 && val.includes(container.id)) {
                            if (! container.solo || container.solo === '') {
                                this.showSolo = true
                            }
                        } else if (val.length === 0) {
                            this.showSolo = false
                        }
                    })
                })
            },
        },
    }
</script>
